import { useState, useEffect, useRef } from "react";
import { MAP_LAYERS } from "../../config/mapLayers";

export function useLayerData(categoryId) {
  const [layerMarkers, setLayerMarkers] = useState([]);
  const [layerMeta, setLayerMeta] = useState(null);
  const [layerLoading, setLayerLoading] = useState(false);
  const [layerError, setLayerError] = useState(null);
  const cacheRef = useRef({});

  useEffect(() => {
    if (!categoryId) {
      setLayerMarkers([]);
      setLayerMeta(null);
      setLayerLoading(false);
      setLayerError(null);
      return;
    }

    const layerConfig = MAP_LAYERS.find((l) => l.categoryId === categoryId);
    if (!layerConfig) {
      setLayerMarkers([]);
      setLayerMeta(null);
      setLayerError("Unknown layer");
      return;
    }

    const cached = cacheRef.current[categoryId];
    if (cached) {
      setLayerMarkers(cached.markers);
      setLayerMeta(cached.meta);
      setLayerLoading(false);
      setLayerError(null);
      return;
    }

    let cancelled = false;
    setLayerLoading(true);
    setLayerError(null);

    fetch(layerConfig.dataUrl)
      .then((r) => {
        if (!r.ok) throw new Error(r.statusText || "Failed to load layer");
        return r.json();
      })
      .then((data) => {
        if (cancelled) return;
        const markers = Array.isArray(data.markers) ? data.markers : [];
        cacheRef.current[categoryId] = { markers, meta: data };
        setLayerMarkers(markers);
        setLayerMeta(data);
        setLayerLoading(false);
      })
      .catch((err) => {
        if (cancelled) return;
        setLayerError(err.message || "Load failed");
        setLayerMarkers([]);
        setLayerMeta(null);
        setLayerLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [categoryId]);

  return { layerMarkers, layerMeta, layerLoading, layerError };
}
